/**
 * React Query hooks for Event Check-ins
 * 
 * Handles check-in functionality for events.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { checkinsApi, type CheckinRequest } from '../lib/api';

/**
 * Create event check-in
 * 
 * On success: Invalidates event query to refresh check-in data
 */
export function useCheckIn(eventId: string) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CheckinRequest) => checkinsApi.createCheckin(eventId, data),
    onSuccess: () => {
      // Refresh event data to show updated check-in status
      queryClient.invalidateQueries({ 
        queryKey: ['event', eventId] 
      });
    },
  });
}
